export type SideBarState =
    | "admin-pannel"
    | "community-management"
    | "event-management"
    | "closed";

export type SideBarRenderState = {
    sideBarState: SideBarState;
    shareModalOpen: boolean;

    setSideBarState: (_state: SideBarState) => void;
    setShareModalOpen: (isOpen: boolean) => void;

    clear: () => void;
};

export const leftSideBarStateStore = (
    set: (state: Partial<SideBarRenderState>) => void,
    get: () => SideBarRenderState,
): SideBarRenderState => ({
    sideBarState: "closed",
    shareModalOpen: false,

    setSideBarState: (_state: SideBarState) => {
        const currentState = get();

        if (currentState.sideBarState !== _state) {
            set({ ...currentState, sideBarState: _state });
        } else {
            set({ ...currentState, sideBarState: "closed" });
        }
    },

    setShareModalOpen: (isOpen: boolean) => {
        const currentState = get();

        if (currentState.shareModalOpen !== isOpen) {
            set({ ...currentState, shareModalOpen: isOpen });
        }
    },

    clear: () => {
        set({
            sideBarState: "closed",
            shareModalOpen: false,
        });
    },
});
